module.exports = __webpack_public_path__ + "img/25.31d201e3.jpg";